import React, { useState, useEffect } from "react";
import { createPortal } from "react-dom";
import { apiUrl } from "../../constants";
import axios from "axios";

const CouponModal = ({ isOpen, onClose }) => {
  const [coupons, setCoupons] = useState([]);
  const Coupons = async () => {
    try {
      const res = await axios.get(`${apiUrl}/coupon/`);
      let couponsData = res.data.coupons;
   
      // Add serial numbers to each coupon instead of using database ID
      const couponsWithSerial = couponsData.map((coupon, index) => ({
        ...coupon,
        serialId: index + 1, 
      }));

      setCoupons(couponsWithSerial);
    } catch (err) {
      console.log(err);
    }
  };
  useEffect(() => {
    Coupons();
  }, []);

  const [copiedCode, setCopiedCode] = useState(null);
  const [portalContainer, setPortalContainer] = useState(null);

  useEffect(() => {
    // Create portal container
    if (typeof document !== "undefined") {
      let container = document.getElementById("modal-portal");
      if (!container) {
        container = document.createElement("div");
        container.id = "modal-portal";
        container.style.cssText = `
          position: fixed;
          top: 0;
          left: 0;
          z-index: 2147483647;
          pointer-events: none;
        `;
        document.body.appendChild(container);
      }
      setPortalContainer(container);
    }

    return () => {
      const container = document.getElementById("modal-portal");
      if (container && container.children.length === 0) {
        document.body.removeChild(container);
      }
    };
  }, []);

  useEffect(() => {
    if (isOpen) {
      
      const scrollY = window.scrollY;
      document.body.dataset.scrollY = scrollY.toString();

      // Prevent scrolling without changing position
      document.body.style.overflow = "hidden";
      document.body.style.paddingRight = "15px";
    } else {
      // Restore scrolling
      document.body.style.overflow = "";
      document.body.style.paddingRight = "";

      // Restore scroll position
      const scrollY = document.body.dataset.scrollY;
      if (scrollY) {
        window.scrollTo(0, parseInt(scrollY));
        delete document.body.dataset.scrollY;
      }
    }

    return () => {
      // Cleanup on unmount
      document.body.style.overflow = "";
      document.body.style.paddingRight = "";
      if (document.body.dataset.scrollY) {
        delete document.body.dataset.scrollY;
      }
    };
  }, [isOpen]);

  const formatDiscount = (coupon) => {
    if (coupon.discount_type === "percentage") {
      return `${coupon.discount}% OFF`;
    }
    return `₹${coupon.discount} OFF`;
  };

  // FIXED: Use coupon.code as the unique identifier instead of coupon.id
  const handleCopyCode = async (coupon) => {
    try {
      await navigator.clipboard.writeText(coupon.code);
      setCopiedCode(coupon.code); // Changed from coupon.id to coupon.code
      setTimeout(() => setCopiedCode(null), 2000);
    } catch (err) {
      console.error("Failed to copy: ", err);
      // Fallback for older browsers
      const textArea = document.createElement("textarea");
      textArea.value = coupon.code;
      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();
      try {
        document.execCommand('copy');
        setCopiedCode(coupon.code);
        setTimeout(() => setCopiedCode(null), 2000);
      } catch (fallbackErr) {
        console.error("Fallback copy failed: ", fallbackErr);
      }
      document.body.removeChild(textArea);
    }
  };

  const closeModal = () => onClose();

  const modalContent = (
    <>
      {/* Modal Overlay */}
      {isOpen && (
        <div
          className="fixed inset-0 bg-black/60 backdrop-blur-sm flex items-start justify-center py-4 px-4"
          onClick={closeModal}
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            zIndex: 2147483647,
            pointerEvents: "all",
          }}
        >
          {/* Modal Content */}
          <div
            className="bg-gradient-to-br from-blue-900 via-slate-900 to-blue-900 rounded-3xl w-full max-w-6xl max-h-[95vh] shadow-2xl relative flex flex-col mt-4"
            onClick={(e) => e.stopPropagation()}
            style={{
              zIndex: 2147483647,
              position: "relative",
            }}
          >
            {/* Modal Header */}
            <div className="flex-shrink-0 bg-slate-900/95 backdrop-blur-lg border-b border-slate-700/50 p-6 flex items-center justify-between rounded-t-3xl">
              <div>
                <h2 className="text-white text-3xl font-bold flex items-center gap-3">
                  🎟️ Available Coupons
                </h2>
                <p className="text-blue-200 text-sm mt-1">
                  Click to copy coupon codes and save on your purchase
                </p>
              </div>

              {/* Close Button */}
              <button
                onClick={closeModal}
                className="bg-red-500/20 hover:bg-red-500 text-red-300 hover:text-white p-3 rounded-full transition-all duration-200 group flex-shrink-0"
                aria-label="Close modal"
              >
                <svg
                  className="w-6 h-6 transform group-hover:rotate-90 transition-transform duration-200"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M6 18L18 6M6 6l12 12"
                  />
                </svg>
              </button>
            </div>

            {/* Scrollable Content */}
            <div
              className="flex-1 overflow-y-auto p-6"
              style={{ maxHeight: "calc(95vh - 140px)" }}
            >
              <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6">
                {coupons.map((coupon) => (
                  <div
                    key={coupon.id}
                    className="relative cursor-pointer transition-all duration-300 transform hover:scale-105"
                  >
                    {/* Coupon Card with Enhanced Shadow */}
                    <div className="relative bg-gradient-to-r from-purple-600 via-pink-500 to-red-500 p-0.5 rounded-2xl overflow-hidden shadow-2xl hover:shadow-purple-500/25">
                      <div className="bg-gradient-to-br from-slate-800 to-slate-900 rounded-2xl p-6 h-full relative overflow-hidden shadow-inner">
                        {/* Background Pattern with Enhanced Effects */}
                        <div className="absolute inset-0 opacity-10">
                          <div className="absolute top-3 right-3 text-5xl animate-pulse">
                            🎟️
                          </div>
                          <div className="absolute bottom-3 left-3 text-3xl animate-bounce">
                            💰
                          </div>
                          <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 text-6xl opacity-5">
                            ✨
                          </div>
                        </div>

                        {/* Coupon Content */}
                        <div className="relative z-10">
                          {/* Header */}
                          <div className="flex items-center justify-between mb-4">
                            <div className="bg-gradient-to-r from-yellow-400 to-orange-500 text-black px-3 py-2 rounded-full text-sm font-bold shadow-lg">
                              {formatDiscount(coupon)}
                            </div>
                            <div className="text-green-400 text-sm font-semibold bg-green-900/30 px-2 py-1 rounded-full border border-green-500/30">
                              {coupon.count} left
                            </div>
                          </div>

                          {/* Coupon Code Section */}
                          <div className="text-center mb-6">
                            <div className="bg-white bg-opacity-10 border-2 border-dashed border-white border-opacity-40 rounded-xl p-4 backdrop-blur-sm shadow-lg">
                              <div className="text-white text-xl font-bold tracking-wider mb-2">
                                {coupon.code}
                              </div>
                              <div className="text-blue-200 text-xs mb-3">
                                Coupon Code
                              </div>

                              {/* Copy Button */}
                              <button
                                onClick={(e) => {
                                  e.stopPropagation();
                                  handleCopyCode(coupon);
                                }}
                                className={`w-full py-2 px-4 rounded-lg text-sm font-medium transition-all duration-200 ${
                                  copiedCode === coupon.code  // Changed from coupon.id to coupon.code
                                    ? "bg-green-500 text-white shadow-green-500/50"
                                    : "bg-blue-500 hover:bg-blue-600 text-white shadow-blue-500/50"
                                } shadow-lg hover:shadow-xl transform hover:scale-105`}
                              >
                                {copiedCode === coupon.code ? (  // Changed from coupon.id to coupon.code
                                  <span className="flex items-center justify-center gap-2">
                                    <svg
                                      className="w-4 h-4"
                                      fill="currentColor"
                                      viewBox="0 0 20 20"
                                    >
                                      <path
                                        fillRule="evenodd"
                                        d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                                        clipRule="evenodd"
                                      />
                                    </svg>
                                    Copied!
                                  </span>
                                ) : (
                                  <span className="flex items-center justify-center gap-2">
                                    <svg
                                      className="w-4 h-4"
                                      fill="none"
                                      stroke="currentColor"
                                      viewBox="0 0 24 24"
                                    >
                                      <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        strokeWidth={2}
                                        d="M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-6 12h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2z"
                                      />
                                    </svg>
                                    Copy Code
                                  </span>
                                )}
                              </button>
                            </div>
                          </div>

                          {/* Details */}
                          <div className="space-y-3 text-sm">
                            <div className="flex justify-between items-center bg-slate-700/50 rounded-lg p-3">
                              <span className="text-blue-300">Type:</span>
                              <span className="text-white font-medium capitalize bg-blue-500/20 px-2 py-1 rounded">
                                {coupon.discount_type}
                              </span>
                            </div>

                            <div className="flex justify-between items-center bg-slate-700/50 rounded-lg p-3">
                              <span className="text-blue-300">Min Amount:</span>
                              <span className="text-green-400 font-medium">
                                ₹{coupon.min_amount.toLocaleString()}
                              </span>
                            </div>

                            {coupon.discount_type === "percentage" && (
                              <div className="flex justify-between items-center bg-slate-700/50 rounded-lg p-3">
                                <span className="text-blue-300">
                                  Max Discount:
                                </span>
                                <span className="text-orange-400 font-medium">
                                  ₹{coupon.max_discount}
                                </span>
                              </div>
                            )}
                          </div>

                          {/* Enhanced Dotted Border Effect */}
                          <div className="absolute left-0 top-1/2 transform -translate-y-1/2 -translate-x-3 w-6 h-6 bg-blue-900 rounded-full border-2 border-dashed border-blue-400/50 shadow-lg"></div>
                          <div className="absolute right-0 top-1/2 transform -translate-y-1/2 translate-x-3 w-6 h-6 bg-blue-900 rounded-full border-2 border-dashed border-blue-400/50 shadow-lg"></div>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>

              {/* Info Section */}
              <div className="mt-8 p-6 bg-blue-900/30 border border-blue-400/30 rounded-2xl backdrop-blur-sm shadow-xl">
                <div className="text-center">
                  <h3 className="text-blue-200 font-bold text-lg mb-2">
                    💡 How to Use
                  </h3>
                  <p className="text-blue-300 text-sm">
                    Click the "Copy Code" button on any coupon to copy it to
                    your clipboard, then paste it during checkout to apply the
                    discount.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );

  if (portalContainer && isOpen) {
    return createPortal(modalContent, portalContainer);
  }

  return modalContent;
};

export default CouponModal;